export default "<app-user-table>\n    <ng-content></ng-content>\n</app-user-table>\n"